<template>
  <v-container>
    <v-row>
      <v-col>
        <div v-if="showHeaderText">
          <p class="headline" :class="{ 'primary--text': isSummaryView }">
            <span class="font-weight-light">
              Is there any other feedback that you would like to share on
              <strong class="primary--text">{{ params.EvaluateeFullName }}</strong> as an input into
              their {{ params.CurrentYear }} APE?
            </span>
          </p>
        </div>

        <div v-if="!isSummaryView">
          <p class="title font-weight-light" v-html="roleModelVerbatimCaption" />
          <v-textarea
            v-model="roleModelVerbatim"
            :rules="[
              v =>
                !isRequired ||
                currentStep !== this.$props.pageNr ||
                (!!v && v.length > 0) ||
                'Please share your comments.'
            ]"
            outlined
          />
          <p class="title font-weight-light" v-html="seeMoreVerbatimCaption" />
          <v-textarea
            v-model="seeMoreVerbatim"
            :rules="[
              v =>
                !isRequired ||
                currentStep !== this.$props.pageNr ||
                (!!v && v.length > 0) ||
                'Please share your comments.'
            ]"
            outlined
          />
        </div>

        <div class="mt-10" v-else>
          <p class="title font-weight-black" v-html="roleModelVerbatimCaption" />
          <p>{{ roleModelVerbatim }}</p>
          <p class="title font-weight-black" v-html="seeMoreVerbatimCaption" />
          <p>{{ seeMoreVerbatim }}</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Improvement',

  props: ['showHeaderText', 'isRequired', 'pageNr', 'isSummaryView'],

  data() {
    return {
      improvementRoleModelVerbatim: 'Improvement_RoleModelVerbatim',
      improvementSeeMoreVerbatim: 'Improvement_SeeMoreVerbatim',
    };
  },

  computed: {
    ...mapGetters(['currentStep', 'isSelfSurvey']),
    params() {
      return this.$store.state.params;
    },
    roleModelVerbatimCaption() {
      return `Thinking of the Partner competencies and capabilities (client, people, leadership, ideas) what <strong>strengths</strong> does <span class="primary--text">${this.$store.state.params.EvaluateeFullName}</span> have? Please provide examples that demonstrate these strengths.`;
    },
    seeMoreVerbatimCaption() {
      return `Thinking of the Partner competencies and capabilities (client, people, leadership, ideas) what <strong>development areas</strong> does  <span class="primary--text">${this.$store.state.params.EvaluateeFullName}</span> have?  Please provide examples to demonstrate how they need improving.`;
    },
    roleModelVerbatim: {
      get() {
        return this.$store.state.response[this.improvementRoleModelVerbatim];
      },
      set(newValue) {
        this.$store.commit('storeResponse', {
          k: this.improvementRoleModelVerbatim,
          v: newValue,
        });
      },
    },
    seeMoreVerbatim: {
      get() {
        return this.$store.state.response[this.improvementSeeMoreVerbatim];
      },
      set(newValue) {
        this.$store.commit('storeResponse', {
          k: this.improvementSeeMoreVerbatim,
          v: newValue,
        });
      },
    },
  },
};
</script>
